import React, { JSX } from 'react';

import { AppBootSplash } from '@/app/shell/app-boot-splash';

import { MonitoringErrorBoundary } from '@/components/error-handling/monitoring-error-boundary';
import AppProvider from '@/app/providers/app-provider';
import AppRoutes from '@/routes/app-routes';

interface UpstackActionData {
  [key: string]: unknown;
}

interface UpsClientEventData {
  [key: string]: unknown;
}

declare global {
  interface Window {
    _upstack?: (action: string, eventName?: string, data?: UpstackActionData) => void;
    _upsClient?: {
      track?: (eventName: string, properties?: UpsClientEventData) => void;
      identify?: (userId: string, data?: UpsClientEventData) => void;
      page?: (pageName: string, data?: UpsClientEventData) => void;
      reset?: () => void;
    };
    _adqLoaded?: number;
    _upsqueue?: unknown[];
  }
}

const App: React.FC = (): JSX.Element => {
  return (
    <MonitoringErrorBoundary>
      <AppProvider>
        {/* Last-resort boot fallback only. Protected pages should resolve lazy work
            under PageLayout / ErrorPageContainer so happy-path navigations keep
            chrome mounted and show in-shell loading states instead. */}
        <React.Suspense fallback={<AppBootSplash />}>
          <AppRoutes />
        </React.Suspense>
      </AppProvider>
    </MonitoringErrorBoundary>
  );
};

export default App;
